import get from "lodash/get";
import React from "react";
import ReactDOM from "react-dom";
import { AuthProvider } from "@xometry/auth-context";
import Component from "./component";
import type {
  ConfigContextData,
  Origins,
} from "./components/proposals/contexts/configContext";
import { getAuthHeadersFromCookie } from "./utils/generalUtils";

const {
  REACT_APP_BASE_DOMAIN: baseDomain,
  REACT_APP_MOCK_STREAM_CHAT: mockStreamChat,
  REACT_APP_SPLITIO_API_KEY: splitIOApiKey,
  REACT_APP_STREAM_API_KEY: streamApiKey,
  REACT_APP_GRAPHQL_URL: graphqlUrl,
  REACT_APP_WORKCENTER_URL: workcenterUrl,
  REACT_APP_THOMASNET_XAPI_URL: thomasnetXApi,
  REACT_APP_THOMASNET_HOME: thomasnetHome,
  REACT_APP_THOMASNET_PUBLIC_GQL: thomasnetPublicGql,
  REACT_APP_THOMASNET_AUTH_GQL: thomasnetAuthGql,
  REACT_APP_MOCK_SERVER: mockGraphqlServer,
  PUBLIC_URL: publicUrl,
} = get(window, "__marketplace_frontend_env__", {}) as any;

const salesEmail = "seller.marketplace@xometry.com";

const toBoolean = (value: any): boolean => {
  return typeof value === "boolean" ? value : value === "true";
};

const envOrDefault = (key, defaultValue) => {
  const val = get(window, ["__marketplace_frontend_env__", key]);
  if (typeof val !== "undefined" && val !== "") {
    return val;
  }
  return defaultValue;
};

const buildXometryDomain = subdomain => {
  return `https://${subdomain}.${baseDomain}`;
};

const origins: Origins = {
  get: envOrDefault("XOM_GET_URL", buildXometryDomain("get")),
  api: envOrDefault("XOM_API_URL", buildXometryDomain("api")),
  auth: envOrDefault("XOM_AUTH_URL", buildXometryDomain("auth")),
  www: envOrDefault("XOM_HOME_URL", buildXometryDomain("www")),
  partFilesService: envOrDefault("XOM_PFS_URL", buildXometryDomain("us-files")),
  graphql: graphqlUrl,
  thomasnetXApi,
  thomasnetHome,
  thomasnetPublicGql,
  thomasnetAuthGql,
  workcenter: workcenterUrl,
  metalsHome: envOrDefault(
    "REACT_APP_THOMASNET_METAL_URL",
    "https://www.metal.thomasnet.com"
  ),
};

const config: ConfigContextData = {
  isThomasnet: /thomasnet.com/.test(window.location.host),
  baseDomain,
  authHeaders: getAuthHeadersFromCookie(),
  origins,
  mockStreamChat: toBoolean(mockStreamChat),
  mockGraphqlServer: toBoolean(mockGraphqlServer),
  splitIOApiKey,
  streamApiKey,
  publicUrl,
  salesEmail,
  renderPaymentsHeader: true,
  partnerId: "",
  isHeadless: false,
  singleForm: {
    id: "",
    onSubmit: async () => false,
    onClose: () => console.log("default close function"),
  },
};

ReactDOM.render(
  <AuthProvider
    config={{
      authOrigin: origins.auth,
      graphqlOrigin: origins.graphql,
      apiOrigin: origins.api,
      includePartner: false,
      userFields:
        "id firstName lastName emailAddress registered itarPromptStatusDefault",
      graphqlEndpoint: `/api/graphql/`,
    }}
  >
    <Component config={config} />
  </AuthProvider>,
  document.getElementById("main")
);
